<div class="filter-container">
  <div class="mb-3 buscador">
    <!-- Campo de búsqueda - se muestra según configuración -->
    <div *ngIf="showSearch" class="input-group form-control search-wrapper">
      <i class="icon-magnifier" aria-hidden="true"></i>
      <input
        [(ngModel)]="searchText"
        type="text"
        placeholder="{{ (type === 'campaigns' ? 'buttons.campaigns-filter' : 'buttons.orders-filter') | translate }}"
        aria-label="Buscar"
        #searchBox
        matInput
        (keyup)="keyup($event)"
        class="placeholder-filter text"
        autocomplete="off"
      />
      <div
        *ngIf="searchText && searchSuggestions.length"
        class="search-suggestions dropdown-suggestions"
      >
        <ng-container *ngFor="let group of searchSuggestions">
          <ng-container *ngFor="let key of objectKeys(group)">
            <div>
              <div class="suggestion-group-header">
                <i class="{{ group[key].icon }}"></i>
                {{ key | titlecase }}
                ( {{ group[key].items.length }} )
              </div>
              <a
                *ngFor="let item of group[key].items"
                class="suggestion-item suggestion-item-link"
                [href]="item.link"
                target="_blank"
              >
                <div>{{ item.data }}</div>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="filter-btn-wrapper" *ngIf="filterFields.length || filterDatesFields.length">
      <button
        class="btn btn-secundario filter-btn"
        type="button"
        (click)="openFilterModal()"
      >
        <span class="filter-btn-text">{{ filterButtonLabel }}</span>
        <i class="icon-equalizer"></i>
      </button>
    </div>

    <!-- Modal Overlay -->
    <div 
      *ngIf="showFilterModal" 
      class="filter-modal-overlay"
      (click)="closeFilterModal()"
    >
      <div class="filter-modal-container" (click)="$event.stopPropagation()">
        <div class="filter-modal-header">
          <h3>{{ "buttons.filter2" | translate }}</h3>
          <button class="modal-close-btn" (click)="closeFilterModal()">
            <i class="icon-cross2"></i>
          </button>
        </div>

        <div class="filter-modal-body">
          <!-- Búsqueda + Presets en la misma fila -->
          <div class="modal-search-presets-row">
            <div *ngIf="showSearch" class="modal-search-wrapper">
              <i class="icon-magnifier" aria-hidden="true"></i>
              <input
                [(ngModel)]="searchText"
                type="text"
                placeholder="{{ (type === 'campaigns' ? 'buttons.campaigns-filter' : 'buttons.orders-filter') | translate }}"
                aria-label="Buscar"
                matInput
                (keyup)="keyup($event)"
                class="modal-search-input"
                autocomplete="off"
              />
              <div
                *ngIf="searchText && searchSuggestions.length"
                class="search-suggestions modal-suggestions dropdown-suggestions w-100"
              >
                <ng-container *ngFor="let group of searchSuggestions">
                  <ng-container *ngFor="let key of objectKeys(group)">
                    <div>
                      <div class="suggestion-group-header">
                        <i class="{{ group[key].icon }}"></i>
                        {{ key | titlecase }}
                        ( {{ group[key].items.length }} )
                      </div>
                      <a
                        *ngFor="let item of group[key].items"
                        class="suggestion-item suggestion-item-link"
                        [href]="item.link"
                        target="_blank"
                      >
                        <div>{{ item.data }}</div>
                      </a>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <!-- Presets selector -->
            <div class="presets-selector-wrapper">
              <div class="main-selector-container presets-selector">
                <div class="floating-label-container"
                  [ngClass]="{
                    'has-value': selectedTemplateName,
                    'is-focused': showTemplatesDropdown
                  }">
                  <label class="floating-label">{{ 'filter_templates.presets' | translate }}</label>
                  <div *ngIf="!showTemplatesDropdown && selectedTemplateName" class="selected-values-display">
                    {{ selectedTemplateName }}
                  </div>
                  <input
                    class="text filter-input"
                    type="text"
                    [style.color]="!showTemplatesDropdown && selectedTemplateName ? 'transparent' : 'inherit'"
                    (focus)="showTemplatesDropdown = true"
                    (blur)="closeTemplatesDropdownDelayed()"
                    autocomplete="off"
                    readonly
                  />
                  <span *ngIf="selectedTemplateName" class="clear-icon"
                    (click)="clearTemplateSelection($event)">
                    <i class="icon-cross2"></i>
                  </span>
                  <span class="icon-chevron-down"></span>
                </div>
                <div class="options-container" *ngIf="showTemplatesDropdown" [ngClass]="{ visible: showTemplatesDropdown }">
                  <div class="option-value template-option" *ngFor="let tpl of templates" (mousedown)="applyTemplate(tpl)">
                    <div class="template-option-row">
                      <span>{{ tpl.name }}</span>
                      <button class="btn-icon template-delete" (mousedown)="deleteTemplate($event, tpl)">
                        <i class="icon-trash"></i>
                      </button>
                    </div>
                  </div>
                  <div class="option-value template-empty" *ngIf="templates.length === 0">
                    {{ 'filter_templates.no_presets' | translate }}
                  </div>
                </div>
              </div>
              <button class="btn btn-primario btn-sm presets-save-btn" type="button" (click)="openSaveTemplateInput()">
                {{ 'filter_templates.save_short' | translate }}
              </button>
            </div>
          </div>

          <!-- Save template input -->
          <div class="templates-save-input" *ngIf="showSaveTemplateInput">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="newTemplateName"
              placeholder="{{ 'filter_templates.enter_name' | translate }}"
              (keyup.enter)="saveTemplate()" />
            <div class="templates-save-actions">
              <button class="btn btn-primario btn-sm" type="button" (click)="saveTemplate()" [disabled]="templateSaving || !newTemplateName.trim()">
                {{ 'buttons.save' | translate }}
              </button>
              <button class="btn btn-secundario btn-sm" type="button" (click)="showSaveTemplateInput = false">
                {{ 'buttons.cancel' | translate }}
              </button>
            </div>
          </div>

          <!-- Filtros normales -->
          <ng-container *ngIf="filterFields.length">
            <div class="filter-section">
             <!--  <h4 class="filter-section-title">{{ "buttons.filter" | translate }}</h4> -->
              <div class="filter-grid">
                <ng-container *ngFor="let field of filterFields">
                  <div class="filter-grid-item">
                    <div class="main-selector-container">
                      <div
                        class="floating-label-container"
                        [ngClass]="{ 
                          expanded: field.visible,
                          'has-value': field.displayText || field.searchTerm,
                          'is-focused': field.optionsVisible
                        }"
                      >
                        <label class="floating-label">
                          {{ 'filter.' + field.placeholder | translate }}
                        </label>
                        
                        <!-- Mostrar displayText cuando no está en foco, searchTerm cuando está buscando -->
                        <div *ngIf="!field.optionsVisible && field.displayText" class="selected-values-display">
                          {{ field.displayText }}
                        </div>
                        
                        <input
                          class="text filter-input"
                          #inputRef
                          type="text"
                          [style.color]="!field.optionsVisible && field.displayText ? 'transparent' : 'inherit'"
                          (focus)="onFocus(field.focus)"
                          (blur)="hideOptions()"
                          (input)="onInputChange(field, $event)"
                          (keydown.escape)="hideOptions()"
                          [(ngModel)]="field.searchTerm"
                          [placeholder]="field.optionsVisible ? 'Buscar...' : ''"
                          autocomplete="off"
                        />

                        <span
                          *ngIf="field.clearable"
                          class="clear-icon"
                          (click)="
                            clearSelectedOption(field); $event.stopPropagation()
                          "
                          ><i class="icon-cross2"></i
                        ></span>

                        <span class="icon-chevron-down"></span>
                      </div>
                      <div
                        class="options-container"
                        *ngIf="field.optionsVisible"
                        [ngClass]="{ visible: field.optionsVisible }"
                      >
                        <div
                          class="option-value"
                          *ngFor="let option of (field.filteredOptions || field.options)"
                          (mousedown)="onSelectOption(option, field, inputRef, $event)"
                        >
                          <div>
                            <input type="checkbox" [checked]="option.selected" (click)="$event.preventDefault()" />
                            {{ option.name }}
                          </div>
                        </div>
                        <div 
                          *ngIf="field.searchTerm && !(field.filteredOptions || field.options).length"
                          class="option-value no-results"
                        >
                          <div>No se encontraron resultados</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- Filtros de fechas -->
          <ng-container *ngIf="filterDatesFields.length">
            <div class="filter-section">
              <h4 class="filter-section-title">{{ "buttons.filterDates" | translate }}</h4>
              <div class="filter-dates-grid">
                <ng-container *ngFor="let field of filterDatesFields">

                  <!-- Select en seccion de fechas (ej: Etapa desde/hasta) -->
                  <div class="filter-dates-column" *ngIf="field.type === 'select'">
                    <div class="date-field-title">{{ 'filter.' + field.placeholder | translate }}</div>
                    <div class="main-selector-container">
                      <div
                        class="floating-label-container"
                        [ngClass]="{
                          expanded: field.visible,
                          'has-value': field.displayText || field.searchTerm,
                          'is-focused': field.optionsVisible
                        }"
                      >
                        <label class="floating-label">
                          {{ 'filter.' + field.placeholder | translate }}
                        </label>
                        <div *ngIf="!field.optionsVisible && field.displayText" class="selected-values-display">
                          {{ field.displayText }}
                        </div>
                        <input
                          class="text filter-input"
                          #inputRef
                          type="text"
                          [style.color]="!field.optionsVisible && field.displayText ? 'transparent' : 'inherit'"
                          (focus)="onFocus(field.focus)"
                          (blur)="hideOptions()"
                          (input)="onInputChange(field, $event)"
                          (keydown.escape)="hideOptions()"
                          [(ngModel)]="field.searchTerm"
                          [placeholder]="field.optionsVisible ? 'Buscar...' : ''"
                          autocomplete="off"
                        />
                        <span
                          *ngIf="field.clearable"
                          class="clear-icon"
                          (click)="clearSelectedOption(field); $event.stopPropagation()"
                        ><i class="icon-cross2"></i></span>
                        <span class="icon-chevron-down"></span>
                      </div>
                      <div
                        class="options-container"
                        *ngIf="field.optionsVisible"
                        [ngClass]="{ visible: field.optionsVisible }"
                      >
                        <div
                          class="option-value"
                          *ngFor="let option of (field.filteredOptions || field.options)"
                          (mousedown)="onSelectOption(option, field, inputRef, $event)"
                        >
                          <div>
                            <input type="checkbox" [checked]="option.selected" (click)="$event.preventDefault()" />
                            {{ option.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Date picker (campos de fecha) -->
                  <div class="filter-dates-column" *ngIf="field.type === 'date'">
                    <div class="date-field-title">{{ 'filter.' + field.placeholder | translate }}</div>

                    <!-- Badges de stages seleccionados en "fecha entrada a etapa" -->
                    <div *ngIf="field.key === 'stage_date_range' && selectedStages.length" class="stage-badges-container">
                      <span *ngFor="let stage of selectedStages"
                        class="badge text-badge-list stage-badge"
                        [ngClass]="(stage.reference || stage.key) | badgeColor:'':'0'">
                        {{ stage.name }}
                      </span>
                    </div>

                    <!-- Fecha Inicio -->
                    <div class="main-selector-container mb-2">
                      <div
                        class="floating-label-container date-picker-container"
                        [ngClass]="{
                          'has-value': filterValues[field.dataKey] && filterValues[field.dataKey][0]
                        }"
                      >
                        <label class="floating-label">
                          {{ 'reports.filter.start_date' | translate }}
                        </label>
                        <div class="date-display-value">
                          {{ filterValues[field.dataKey] && filterValues[field.dataKey][0] 
                             ? (filterValues[field.dataKey][0] | date: 'dd/MM/yyyy') 
                             : '' }}
                        </div>
                        <span
                          *ngIf="filterValues[field.dataKey] && filterValues[field.dataKey][0]"
                          class="clear-icon date-clear-icon"
                          (click)="clearDateFilter(field.dataKey, 'startDate'); $event.stopPropagation()"
                        >
                          <i class="icon-cross2"></i>
                        </span>
                        <mat-form-field appearance="fill" class="date-field-wrapper">
                          <input
                            matInput
                            [matDatepicker]="startDatePicker"
                            (dateChange)="onDateChange($event, 'startDate', field.dataKey)"
                            [ngModel]="
                              filterValues[field.dataKey]
                                ? filterValues[field.dataKey][0]
                                : null
                            "
                            readonly
                            class="datepicker-hidden"
                          />
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="startDatePicker"
                            class="date-toggle"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    
                    <!-- Fecha Fin -->
                    <div class="main-selector-container">
                      <div
                        class="floating-label-container date-picker-container"
                        [ngClass]="{
                          'has-value': filterValues[field.dataKey] && filterValues[field.dataKey][1]
                        }"
                      >
                        <label class="floating-label">
                          {{ 'reports.filter.end_date' | translate }}
                        </label>
                        <div class="date-display-value">
                          {{ filterValues[field.dataKey] && filterValues[field.dataKey][1] 
                             ? (filterValues[field.dataKey][1] | date: 'dd/MM/yyyy') 
                             : '' }}
                        </div>
                        <span
                          *ngIf="filterValues[field.dataKey] && filterValues[field.dataKey][1]"
                          class="clear-icon date-clear-icon"
                          (click)="clearDateFilter(field.dataKey, 'endDate'); $event.stopPropagation()"
                        >
                          <i class="icon-cross2"></i>
                        </span>
                        <mat-form-field appearance="fill" class="date-field-wrapper">
                          <input
                            matInput
                            [matDatepicker]="endDatePicker"
                            (dateChange)="onDateChange($event, 'endDate', field.dataKey)"
                            [ngModel]="
                              filterValues[field.dataKey]
                                ? filterValues[field.dataKey][1]
                                : null
                            "
                            readonly
                            class="datepicker-hidden"
                          />
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="endDatePicker"
                            class="date-toggle"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
        
        <div class="filter-modal-footer">
          <button class="btn btn-hover" type="button" (click)="closeFilterModal()">
            {{ "buttons.aplyFilter" | translate }}
          </button>
        </div>
      </div>
    </div>
    <!-- Checkbox require_action - desktop: checkbox + label, mobile: icon toggle -->
    <div *ngIf="showRequireAction" class="require-action-wrapper">
      <!-- Desktop version -->
      <div class="form-check require-action require-action-desktop">
        <input
          #requireActionCheckbox
          class="form-check-input"
          type="checkbox"
          value=""
          id="flexCheckDefault"
          [checked]="requireActionActive"
          (change)="
            requireActionActive = !requireActionActive;
            onSelectOption(
              { type: 'checkbox' },
              { key: 'require_action' },
              requireActionCheckbox
            )
          "
        />
        <label class="form-check-label" for="flexCheckDefault">
          {{ "buttons.require-action" | translate }}
        </label>
      </div>
      <!-- Mobile version: icon toggle -->
      <button
        type="button"
        class="require-action-mobile"
        [class.active]="requireActionActive"
        (click)="requireActionActive = !requireActionActive; requireActionCheckbox.checked = requireActionActive; onSelectOption({ type: 'checkbox' }, { key: 'require_action' }, requireActionCheckbox)"
        [title]="'buttons.require-action' | translate"
      >
        <i class="icon-flag"></i>
      </button>
    </div>
   
    <div *ngIf="showClear" class="clear">
      <button
        class="btn btn-hover clear-button"
        type="button"
        (click)="clearAllFilter($event)"
      >
        {{ "buttons.clearFilter" | translate }}
      </button>
    </div>
  </div>
</div>
